import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CardService } from 'src/app/services/card/card.service';
import { CommonService } from 'src/app/services/common/common.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { NetworkStatus } from 'src/app/enums/network-status.enum';

@Component({
	selector: 'vtr-widget-hardware-scan-support-card',
	templateUrl: './widget-hardware-scan-support-card.component.html',
	styleUrls: ['./widget-hardware-scan-support-card.component.scss'],
})
export class WidgetHardwareScanSupportCardComponent implements OnInit, OnDestroy {
	@Input() widgetId: string;

	private linkAddress = 'https://pcsupport.lenovo.com/lenovodiagnosticsolutions/downloads';
	public title = 'hardwareScan.support.title';
	public description = 'hardwareScan.support.description';
	public tooltipText = 'hardwareScan.support.title';
	public isOnline = true;
	private notificationSubscription: Subscription;

	constructor(private commonService: CommonService, private cardService: CardService) {}

	ngOnInit() {
		this.isOnline = this.commonService.isOnline;
		this.notificationSubscription = this.commonService.notification.subscribe(
			(notification: AppNotification) => {
				this.onNotification(notification);
			}
		);
	}

	ngOnDestroy() {
		if (this.notificationSubscription) {
			this.notificationSubscription.unsubscribe();
		}
	}

	public linkClicked(): void {
		this.cardService.linkClicked('External', this.linkAddress, false);
	}

	private onNotification(notification: AppNotification): void {
		if (notification) {
			switch (notification.type) {
				case NetworkStatus.Online:
				case NetworkStatus.Offline:
					this.isOnline = notification.payload.isOnline;
					break;
				default:
					break;
			}
		}
	}
}
